import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export function AuthInput({ className, ...props }: React.ComponentProps<typeof Input>) {
  return (
    <Input className={cn('h-auto border-auth-tint bg-muted px-3 py-3', className)} {...props} />
  );
}
